// src/components/attendance/AttendanceManager.jsx
import React, { useState } from 'react';
import { Users, ArrowLeft } from 'lucide-react';
import AttendanceList from './AttendanceList';
import AttendanceForm from '../forms/AttendanceForm';
import AttendanceDetail from './AttendanceDetail';

const AttendanceManager = () => {
  const [currentView, setCurrentView] = useState('list'); // 'list', 'form', 'detail'
  const [selectedSession, setSelectedSession] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const handleCreateNew = () => {
    setSelectedSession(null);
    setIsEditing(false);
    setCurrentView('form');
  };

  const handleEdit = (session) => {
    setSelectedSession(session);
    setIsEditing(true);
    setCurrentView('form');
  };

  const handleView = (session) => {
    setSelectedSession(session);
    setCurrentView('detail');
  };

  const handleFormSubmit = () => {
    setCurrentView('list');
    setSelectedSession(null);
    setIsEditing(false);
  };

  const handleBack = () => {
    setCurrentView('list');
    setSelectedSession(null);
    setIsEditing(false);
  };

  const renderContent = () => {
    switch (currentView) {
      case 'form':
        return (
          <AttendanceForm
            initialData={isEditing ? selectedSession : null}
            onSubmit={handleFormSubmit}
            onCancel={handleBack}
          />
        );
      
      case 'detail':
        return (
          <AttendanceDetail
            session={selectedSession}
            onBack={handleBack}
            onEdit={handleEdit}
          />
        );
      
      default:
        return (
          <AttendanceList
            onCreateNew={handleCreateNew}
            onEdit={handleEdit}
            onView={handleView}
          />
        );
    }
  };

  return (
    <div className="max-w-6xl mx-auto space-y-6">
      {/* Header - only show on list view */}
      {currentView === 'list' && (
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center gap-3">
            <Users className="w-6 h-6 text-blue-600" />
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Attendance Management</h1>
              <p className="text-gray-600">
                Record and track class attendance, engagement, and session details
              </p>
            </div>
          </div>
        </div>
      )}

      <div className="max-w-6xl mx-auto space-y-6">
      {renderContent()}
      </div>
    </div>
  );
};

export default AttendanceManager;